import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import PurchasePriceInput from '../purchase-price';

const PurchasePriceInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <PurchasePriceInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default PurchasePriceInputWithAnalytics;
